module.exports = __webpack_public_path__ + "static/img/41.8f080801.png";